import styled from 'styled-components/macro'

import Typography from '@material-ui/core/Typography'

const P = styled(Typography)`
  margin: 10px 0;
  font-size: 1rem;
`

export default P
